import React, { useState } from 'react'
import { ActivityIndicator, Image, Platform } from 'react-native'

import {
  H2,
  H4,
  Icon,
  Stack,
  stringToHslColor,
  colors as zetColors,
} from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { useUserContext } from '@zet/feature-user'

import { useUpdateProfilePic } from '../../api/login/hooks'
import UploadProfilePicture from '../../components/login/uploadProfilePicture'

const ProfilePicture = () => {
  const { data } = useUserContext()
  const [isUploadBottomSheetVisible, setIsUploadBottomSheetVisible] =
    useState(false)

  const { isLoading, mutate } = useUpdateProfilePic()

  const getInitials = (name: string) => {
    const nameArray = name
      .trim()
      .replace(/[^a-zA-Z ]/g, '')
      .split(' ')
    if (nameArray.length === 1) return nameArray[0].charAt(0).toUpperCase()
    else if (nameArray.length > 1) {
      return (
        nameArray[0].charAt(0).toUpperCase() +
        nameArray[1].charAt(0).toUpperCase()
      )
    }
  }

  const backgroundColor = stringToHslColor(data?.name ?? '', 50, 75)

  // TODO: Find a good library for the image picker and upload
  const handlePress = () => {
    if (Platform.OS !== 'web') setIsUploadBottomSheetVisible(true)
  }

  return (
    <Stack className="border-grays-30 border-b pb-4">
      <Pressable className="bg-neutral-white100 mb-1 p-4" onPress={handlePress}>
        <Stack
          className="border-grays-40 self-center overflow-hidden rounded-md border"
          style={{ width: 80, height: 80 }}
        >
          {isLoading ? (
            <Stack className="h-full items-center justify-center">
              <ActivityIndicator color={zetColors.primary[100]} />
            </Stack>
          ) : data?.imageUrl && !data?.imageUrl?.includes('null') ? (
            <Image
              source={{
                uri: data?.imageUrl,
              }}
              style={{ height: '100%' }}
            />
          ) : (
            <Stack
              className="flex-1 items-center justify-center"
              style={{ backgroundColor }}
            >
              <H2>{getInitials(data?.name ?? '')}</H2>
            </Stack>
          )}
          {Platform.OS !== 'web' && (
            <Stack className="bg-primary-50 absolute bottom-0 right-0 h-4 w-4 items-center justify-center rounded-sm">
              <Icon
                size={24}
                color="white"
                className="p-1"
                type="CameraFilled"
              />
            </Stack>
          )}
        </Stack>
      </Pressable>
      <H4 className="text-center">{data?.fullName}</H4>
      <UploadProfilePicture
        isUploadBottomSheetVisible={isUploadBottomSheetVisible}
        setIsUploadBottomSheetVisible={setIsUploadBottomSheetVisible}
        mutate={mutate}
      />
    </Stack>
  )
}

export default ProfilePicture
